// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardPinResponseModel {
    'accountNumber'?: string;
    'last4'?: string;
    'pin'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardPinResponseModel>> = [
        {
            "name":     "accountNumber",
            "baseName": "accountNumber",
            "type":     "string"
        },
        {
            "name":     "last4",
            "baseName": "last4",
            "type":     "string"
        },
        {
            "name":     "pin",
            "baseName": "pin",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardPinResponseModel.attributeTypeMap;
    }
}
